import { useNavigate } from "react-router-dom";
import { useUserRole } from "./useUserRole";
import { toast } from "sonner";

export const usePermissionRedirect = () => {
  const navigate = useNavigate();
  const { canWrite, canAccessGroups, canAccessCalendarSync, canAccessTelegram, role, loading } = useUserRole();

  const checkPersonalAccess = () => {
    if (loading) return true;
    if (!canWrite) {
      toast.error("Your account is read-only", {
        description: "Resubscribe to start editing personal leads again.",
        action: { label: "Resubscribe", onClick: () => navigate("/pricing") },
      });
      navigate("/pricing");
      return false;
    }
    return true;
  };

  const checkGroupAccess = () => {
    if (loading) return true;
    if (!canAccessGroups) {
      toast.error("Upgrade to access groups", {
        description: "Group workspaces require the Business tier.",
        action: {
          label: "View Plans",
          onClick: () => navigate("/pricing"),
        },
      });
      navigate("/pricing");
      return false;
    }
    return true;
  };

  const checkGroupLimit = async (): Promise<boolean> => {
    if (loading) return true;
    if (role === "business" || role === "admin" || role === "membership") return true;
    toast.error("Upgrade to access groups", {
      description: "Group workspaces require the Business tier.",
      action: { label: "View Plans", onClick: () => navigate("/pricing") },
    });
    navigate("/pricing");
    return false;
  };

  const checkTelegramAccess = () => {
    if (loading) return true;
    if (!canAccessTelegram) {
      toast.error("Upgrade to access Telegram integration", {
        description: "Resubscribe to a paid plan to use the Telegram bot.",
        action: {
          label: "View Plans",
          onClick: () => navigate("/pricing"),
        },
      });
      navigate("/pricing");
      return false;
    }
    return true;
  };

  const checkCalendarAccess = () => {
    if (loading) return true;
    if (!canAccessCalendarSync) {
      toast.error("Upgrade to access Google Calendar sync", {
        description: "Resubscribe to a paid plan to use Google Calendar sync.",
        action: {
          label: "View Plans",
          onClick: () => navigate("/pricing"),
        },
      });
      navigate("/pricing");
      return false;
    }
    return true;
  };

  return {
    checkPersonalAccess,
    checkGroupAccess,
    checkGroupLimit,
    checkTelegramAccess,
    checkCalendarAccess,
  };
};
